// extracted by mini-css-extract-plugin
export default {"root":"styles_root__n7wV9","icon":"styles_icon__f6idA"};